import { createEnv } from '@t3-oss/env-nextjs';
import * as z from 'zod';

export const env = createEnv({
  shared: {
    NODE_ENV: z.enum(['development', 'test', 'production']).optional(),
  },
  client: {
    NEXT_PUBLIC_PIE_ENV: z.enum(['feature01', 'feature03', 'staging', 'production', 'post-prod']),
    NEXT_PUBLIC_VERCEL_ENV: z.enum([
      'development',
      'preview',
      'feature01',
      'feature03',
      'staging',
      'production',
      'post-prod',
    ]),
    NEXT_PUBLIC_DATADOG_APPLICATION_ID: z.string().optional(),
    NEXT_PUBLIC_DATADOG_CLIENT_TOKEN: z.string().optional(),
    NEXT_PUBLIC_GIT_SHA: z.string().optional(),
    NEXT_PUBLIC_COGNITO_USER_POOL_ID: z.string().min(1),
    NEXT_PUBLIC_COGNITO_CLIENT_ID: z.string().min(1),
    NEXT_PUBLIC_COOKIE_DOMAIN: z.string().min(1),
    NEXT_PUBLIC_FILE_CLAIM_URL: z.string().min(1),
    NEXT_PUBLIC_LAUNCHDARKLY_CLIENT_KEY: z.string().min(1),
    NEXT_PUBLIC_BUILDER_IO_API_KEY: z.string().min(1),
    NEXT_PUBLIC_LEGACY_DOMAIN: z.string().min(1),

    // Each environment reports to its own Mixpanel project, so this differs per
    // deploy target. Optional rather than required: where it is unset analytics
    // stays inert instead of failing the build.
    NEXT_PUBLIC_MIXPANEL_TOKEN: z.string().optional(),

    // Local-dev only: routes the payment dialog's session request to the dev-only
    // `/api/dev/zuora-session` mint route (Zuora dev tenant) instead of the real
    // billing API. Off by default; never set in production.
    NEXT_PUBLIC_MOCK_PAYMENT_SESSION: z.stringbool().optional().default(false),
    // Zuora HPM submit URL — must be set explicitly for every Vercel environment.
    NEXT_PUBLIC_ZUORA_HPP_URL: z.string().min(1),
  },
  runtimeEnv: {
    NODE_ENV: process.env.NODE_ENV,
    NEXT_PUBLIC_PIE_ENV: process.env.NEXT_PUBLIC_PIE_ENV,
    NEXT_PUBLIC_VERCEL_ENV: process.env.NEXT_PUBLIC_VERCEL_ENV,
    NEXT_PUBLIC_DATADOG_APPLICATION_ID: process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID,
    NEXT_PUBLIC_DATADOG_CLIENT_TOKEN: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
    NEXT_PUBLIC_COGNITO_USER_POOL_ID: process.env.NEXT_PUBLIC_COGNITO_USER_POOL_ID,
    NEXT_PUBLIC_COGNITO_CLIENT_ID: process.env.NEXT_PUBLIC_COGNITO_CLIENT_ID,
    NEXT_PUBLIC_COOKIE_DOMAIN: process.env.NEXT_PUBLIC_COOKIE_DOMAIN,
    NEXT_PUBLIC_LAUNCHDARKLY_CLIENT_KEY: process.env.NEXT_PUBLIC_LAUNCHDARKLY_CLIENT_KEY,
    NEXT_PUBLIC_GIT_SHA: process.env.NEXT_PUBLIC_GIT_SHA,
    NEXT_PUBLIC_FILE_CLAIM_URL:
      process.env.NEXT_PUBLIC_FILE_CLAIM_URL ?? 'https://forms.gle/fpBptRkvQUt6rA8d8',
    NEXT_PUBLIC_BUILDER_IO_API_KEY: process.env.NEXT_PUBLIC_BUILDER_IO_API_KEY,
    NEXT_PUBLIC_LEGACY_DOMAIN: process.env.NEXT_PUBLIC_LEGACY_DOMAIN,
    NEXT_PUBLIC_MIXPANEL_TOKEN: process.env.NEXT_PUBLIC_MIXPANEL_TOKEN,
    NEXT_PUBLIC_MOCK_PAYMENT_SESSION: process.env.NEXT_PUBLIC_MOCK_PAYMENT_SESSION,
    NEXT_PUBLIC_ZUORA_HPP_URL: process.env.NEXT_PUBLIC_ZUORA_HPP_URL,
    ZUORA_OAUTH_TOKEN: process.env.ZUORA_OAUTH_TOKEN,
    ZUORA_OAUTH_CLIENT_ID: process.env.ZUORA_OAUTH_CLIENT_ID,
    ZUORA_OAUTH_CLIENT_SECRET: process.env.ZUORA_OAUTH_CLIENT_SECRET,
    ZUORA_ACCOUNT_ID: process.env.ZUORA_ACCOUNT_ID,
    ZUORA_REST_HOST: process.env.ZUORA_REST_HOST,
    ZUORA_HPP_URL: process.env.ZUORA_HPP_URL,
    ZUORA_PAGE_ID_CARD: process.env.ZUORA_PAGE_ID_CARD,
    ZUORA_PAGE_ID_ACH: process.env.ZUORA_PAGE_ID_ACH,
  },
  server: {
    ZUORA_OAUTH_TOKEN: z.string().optional(),
    ZUORA_OAUTH_CLIENT_ID: z.string().optional(),
    ZUORA_OAUTH_CLIENT_SECRET: z.string().optional(),
    ZUORA_ACCOUNT_ID: z.string().optional(),
    ZUORA_REST_HOST: z.string().optional(),
    ZUORA_HPP_URL: z.string().optional(),
    ZUORA_PAGE_ID_CARD: z.string().optional(),
    ZUORA_PAGE_ID_ACH: z.string().optional(),
  },
  skipValidation: process.env.NODE_ENV === 'test' || !!process.env.SKIP_ENV_VALIDATION,
});
